export const KYC_ROUTE = '/kyc';
export const KYC_SUCCESS_ROUTE = '/kyc/success';
